export default __webpack_public_path__ + "static/media/legs_3_male.cf721add.png";